/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { dashboardsGet } from "../funcs/dashboardsGet.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { Dashboard } from "../models/components/dashboard.js";
import {
  GetDashboardRequest,
  GetDashboardSecurity,
} from "../models/operations/getdashboard.js";
import { unwrapAsync } from "../types/fp.js";
export type DashboardQueryData = Dashboard;

export function prefetchDashboard(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetDashboardRequest,
  security?: GetDashboardSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildDashboardQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildDashboardQuery(
  client$: GramCore,
  request: GetDashboardRequest,
  security?: GetDashboardSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<DashboardQueryData>;
} {
  return {
    queryKey: queryKeyDashboard({
      id: request.id,
      gramSession: request.gramSession,
      gramProject: request.gramProject,
    }),
    queryFn: async function dashboardQueryFn(ctx): Promise<DashboardQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(dashboardsGet(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyDashboard(
  parameters: {
    id: string;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "dashboards", "get", parameters];
}
